import { Actioner, GTMActionKeys } from "@services/actioner";
import { assign } from "lodash";
import { useEffect, useRef } from "react";

const useWebBuyFormErrorLogger = (errors, deps = []) => {
	const formErrorDetails = useRef(null);
	const errorDeps = deps.map((dep) => errors[dep]);

	useEffect(() => {
		if (typeof errors === "string" || errors instanceof String) {
			if (errors.length) {
				formErrorDetails.current = errors;
			}
		} else if (errors && Object.keys(errors).length !== 0) {
			const errorClone = {};
			Object.keys(errors).forEach((key) => {
				assign(errorClone, { [key]: errors[key].message || errors[key] });
			});

			formErrorDetails.current = {
				...formErrorDetails.current,
				...errorClone,
			};
		}
	}, [errors, ...errorDeps]);

	const sendFormErrorEvent = () => {
		if (formErrorDetails.current) {
			Actioner.trigger(GTMActionKeys.FORM_ERROR, {
				formName: "web_buy",
				formErrorDetails: JSON.stringify(formErrorDetails.current),
			});
		}
	};

	return { sendFormErrorEvent };
};

export default useWebBuyFormErrorLogger;
